import { render, staticRenderFns } from "./DashboardWidgetSkeleton.vue?vue&type=template&id=1e737027&scoped=true"
import script from "./DashboardWidgetSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetSkeleton.vue?vue&type=style&index=0&id=1e737027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e737027",
  null
  
)

export default component.exports